import React, { ChangeEvent, FC } from "react";

interface Props {
  value: boolean;
  inputAttrs?: any;
  onChange: (value: boolean) => void;
  errorMessage?: string;
}

export const FormToggle: FC<Props> = ({
  value,
  inputAttrs,
  onChange,
  errorMessage,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <div>
      <label className="formToggle">
        <input
          type="checkbox"
          {...inputAttrs}
          checked={value}
          onChange={handleChange}
          className="sr-only"
        />
        <div className={`formToggle--pill ${value ? "checked" : ""}`}>
          <div className="formToggle--pill-circle" />
        </div>
      </label>
      {errorMessage && (
        <span className="formToggle--error">{errorMessage}</span>
      )}
    </div>
  );
};
